import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ScrollToTop from "./globals/scroll-to-top";
import RootLayout from "./layouts/root-layout";
import { AuthProvider } from "./contexts/AuthContext";

// Create a client with optimized cache settings
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10 * 60 * 1000, // Data stays fresh for 10 minutes
      gcTime: 60 * 60 * 1000, // Keep unused data in cache for 1 hour (formerly cacheTime)
      refetchOnWindowFocus: false, // Don't refetch on window focus
      refetchOnReconnect: false, // Don't refetch on reconnect
      refetchOnMount: false, // Don't refetch on component mount if data exists
      retry: 1, // Only retry once on failure
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ScrollToTop />
        <RootLayout />
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
